<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import Button from '../common/Button.svelte';
  import RocketHandBox from '../ui-components/RocketHandBox.svelte';
  import PageBox from '../ui-components/PageBox.svelte';
  import Common from '../js/common.js';

  if (!Global.pages.includes('rocket-hand')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;
  let mode;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let values = [];
  let page;

  let loading = true;
  let error = false;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/rocketHand/get`);

    if (response.ok) {
      const data = await response.json();

      values = Common.sortArrayOfObjectsByKey(data.values, ['speed', 'lastName', 'firstName'], true);
      page = data.page;
      user = data.user;

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');
    } else {
      error = true;
    }

    loading = false;
  })();

  async function updateRocketHand () {
    // eslint-disable-next-line no-undef
    await fetch(`${Common.BACKEND_URL}/rocketHand/update`);
  }

  const i18n = {
    pageTitle: {
      cs: `Raketová ruka | ${Global.project.name.cs}`,
      en: `Rocket hand | ${Global.project.name.en}`,
    },
    title: {
      cs: 'Raketová ruka',
      en: 'Rocket hand',
    },
    updateRocketHand: {
      cs: 'Aktualizovat raketovou ruku',
      en: 'Update rocket hand',
    },
  };
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='rocket-hand' bind:lang bind:user bind:mode/>

<Title title={i18n.title[lang]} color='red' img='title/rocket-hand.jpg' bind:lang bind:user/>

<div class='rocket-hand'>
  <Loading bind:display={loading}/>
  <Error bind:display={error} bind:lang/>

  {#if !loading && !error}
    <div class='rocket-hand-content'>
      {#if user}
        <div class='rocket-hand-content-admin'>
          <Button value={i18n.updateRocketHand[lang]} icon='refresh' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
            onClick={async () => { await updateRocketHand(); }}/>
        </div>
      {/if}

      <div class='rocket-hand-content-main'>
        <RocketHandBox values={values} bind:lang bind:mode/>
      </div>
    </div>

    <PageBox value={page} page='rocket-hand' bind:lang bind:user/>
  {/if}
</div>

<Footer bind:lang/>

<style>
  .rocket-hand {
    display: flex;
    flex-direction: column;
    gap: 40px;

    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .rocket-hand-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  @media only screen and (max-width: 900px) {
    .rocket-hand {
      padding: 40px;
    }
  }

  @media only screen and (max-width: 350px) {
    .rocket-hand {
      padding: 40px 20px;
    }
  }
</style>
